import { useContext, useEffect, useRef, useState } from 'react'
import VehiclesTable from '../components/vehicle/VehicleTable'
import { getRequest } from '../services/base'
import { useSearchParams } from 'react-router-dom'
import { NavContext } from '../context/global_context'
import { PageHeaders } from '../config/PageHeaders'
import {
  deleteSessionStorage,
  setSessionStorageData,
} from '../utils/SessionStorage'
import { useVehicles } from '../context/vehicle_context'

const Vehicle = () => {
  const [value, dispatch] = useContext(NavContext)
  const [searchParams, setSearchParams] = useSearchParams()
  const { vehicles, setVehiclesData, pagination, setPagination } = useVehicles()
  const currentUrl = useRef(
    `/api/vehicles/?search=${
      searchParams.get('search') ? searchParams.get('search') : ''
    }`
  )

  const setFilterValues = () => {
    let queryParams = {}
    searchParams.forEach((value, key) => {
      queryParams[key] = value
    })
    setSessionStorageData('vehicle', queryParams)
  }

  useEffect(() => {
    dispatch({
      type: 'header',
      data: {
        ...PageHeaders.vehicle,
        show_back_btn: false,
        dtc_details: {},
        full_width_container: false,
      },
    })
    setFilterValues()

    deleteSessionStorage('dtcs_list')
    getVehicles(null)

    return () => {
      setFilterValues()
    }
  }, [])

  const getVehicles = async () => {
    let response = await getRequest(currentUrl.current)
    setVehiclesData(response.results)
    setPagination(response.pagination)
  }

  return (
    vehicles &&
    pagination && (
      <VehiclesTable
        pagination={pagination}
        getPaginatedData={(url) => {
          if (url) {
            currentUrl.current = url
          }
          getVehicles()
        }}
      />
    )
  )
}

export default Vehicle
